
import api from "~api";
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Drawer from 'vux/src/components/drawer/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Calendar from 'vux/src/components/calendar/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import ChinaAddressData from 'vux/src/datas/china_address.json'
import Datetime from 'vux/src/components/datetime/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

export default {
components: {
XHeader,Group,Cell,XInput,XNumber,XButton,ChinaAddressData,XAddress,Selector,Tabbar,TabbarItem,Drawer,ViewBox,Calendar,Checker, CheckerItem,Datetime ,Toast
},
data () {
return {
addressData: ChinaAddressData,
startdate:'TODAY',
arrivedate: 'TODAY',
tripway :[{key:"火车",value:"火车"},{key:"飞机",value:"飞机"},{key:"大巴",value:"大巴"},{key:"其它",value:"其它"}],
note:'',
alonenum:'2',
schoolbussite:[],
schoolbustime:[],
isopen:'0',
showBool: false,
info:{









},
dateList:[],
editBool: true,
bool:true,
lookBool:false,
goBool:false,
onBool:true,
startTime: "",
endTime: "",
showtoast:false,
toasttext:'',
changeBool: false,
nowyear: new Date().getFullYear()
}
},
mounted () {
var flowdata = JSON.parse(window.localStorage.getItem('flowdata'));
var sort = this.$route.params.sort;
for (var i = 0;i<flowdata.length;i++){
if(flowdata[i].sort==sort){
if(flowdata[i].skip=='1'){
this.goBool = true;
}else{
this.goBool = false;
}
}
}
this.getData()
},
methods: {
checkAddress(){
if(this.info.startCity == '' || this.info.startCity == [] || this.info.startCity == null){
this.toasttext = "请选择出发城市";
this.showtoast=true;
return false;
}
return true;
},
checkMode(){
if(this.info.tripMode == '' || this.info.tripMode ==null){
this.toasttext = "请选择出行方式";
this.showtoast=true;
return false;
}
return true;
},
checkRemark(){
if(this.info.remark == '' || this.info.remark ==null){
this.toasttext = "请输入备注";
this.showtoast=true;
return false;
}
return true;
},
checkTime(){
if(this.info.schoolbusSite == '' || this.info.schoolbusSite ==null){
this.toasttext = "请选择到达时间";
this.showtoast=true;
return false;
}
return true;
},
checkRemarks(){
if(this.info.remarks == '' || this.info.remarks ==null){
this.toasttext = "请输入备注";
this.showtoast=true;
return false;
}
return true;
},
checkstartDate(){
if(this.info.startDate == '' || this.info.startDate ==null){
this.toasttext = "请输入出发日期";
this.showtoast=true;
return false;
}else{
this.startTime = this.info.startDate;
}
return true;
},

checkarriveDate(){
if(this.info.arriveDate == '' || this.info.arriveDate ==null){
this.toasttext = "请输入到达日期";
this.showtoast=true;
return false;
}else{
this.endTime = this.info.arriveDate;
}
return true;
},
checkNum(){
var numreg = /^[0-9]+$/;
if(this.info.heelNum == '' || this.info.heelNum ==null){
this.toasttext = "请输入随行人数";
this.showtoast=true;
return false;
}else if (!numreg.test(this.info.heelNum)){
this.toasttext = "请输入正确的随行人数";
this.showtoast=true;
return false;
}
return true;
},
checkStatus(){
if(this.info.status == '' || this.info.status ==null){
this.toasttext = "请选择是否公开个人信息";
this.showtoast=true;
return false;
}
return true;
},
getData(){











api.post("/api/TravelInformation/findBusInformation",{"stuCode":window.localStorage.getItem("stuCode")}).then( res=>{
if(res.data!=null){
if(res.data.results==false){
this.editBool = false;
}else{





res.data.results[0].startCity = res.data.results[0].startCity.split(",");
this.info = res.data.results[0];

if(this.info.status=="1"){
this.lookBool = true;
}else{
this.lookBool = false;
}
}
}
})




},
unique(arr) {


const res = new Map();

return arr.filter((arr) => !res.has(arr.beginSite) && res.set(arr.beginSite, 1))
},


changeDate (datestr) {
var temp = datestr.split("-");
if (temp[1] === '01') {
temp[0] = parseInt(temp[0],10) - 1;
temp[1] = '12';
} else {
temp[1] = parseInt(temp[1],10) - 1;
}

var date = new Date(temp[0], temp[1], temp[2]);
return date;
},
onChange(){
if(this.info.schoolbusSite == '' || this.info.schoolbusSite ==null){
this.toasttext = "请选择校车站点";
this.showtoast=true;
return false;
}


































return true;
},
goSchool () {
var _this = this;
_this.$router.push({name: 'friendRecommended'});
},
goNext () {
var _this = this;
var flowdata = JSON.parse(window.localStorage.getItem('flowdata'));
var sort = _this.$route.params.sort;
var urlname = '';
var stunum = _this.$route.params.stunum;
for (var i = 0;i<flowdata.length;i++){
if(flowdata[i].sort>sort){
sort = flowdata[i].sort;
urlname = flowdata[i].urlname;
_this.$router.push({name: urlname,params:{sort:sort,stunum:stunum}});
return;
}/*else{
_this.$router.push({name: 'generateform',params:{stunum:stunum}});
}*/
}
},
viewmate(){
var _this = this;
var params = {
"stuCode": window.localStorage.getItem("stuCode"),
"startCity":this.info.startCity.join(","),
"startDate":this.info.startDate
};

_this.$router.push({name: 'friendRecommended',params:{sort:_this.$route.params.sort,stunum:_this.$route.params.stunum,params:params,city:this.$refs.xaddress.nameValue}});

},
onSubmit(){
this.changeBool = true;
if(this.checkAddress() && this.checkstartDate() && this.checkarriveDate() && this.checkTime() && this.checkMode()  && this.checkStatus()){
this.changeBool = false;
var params = {
"startCity": this.info.startCity.join(","),
"startDate": this.info.startDate,
"arriveDate": this.info.arriveDate,
"tripMode": this.info.tripMode,
"remark": this.info.remark,
"heelNum": this.info.heelNum,
"schoolbusSite": this.info.schoolbusSite,

"remarks": this.info.remarks,
"stuCode": window.localStorage.getItem("stuCode"),
"status": this.info.status,
"processId":this.$route.params.sort
};
console.log("===="+JSON.stringify(params))
if(this.editBool){
api.post("/api/TravelInformation/updateBusInformation",params).then( res=>{
if(res.data!=null){
if(res.data.results){
if(params.status=="1"){
this.onBool = false;
this.goBool = true;
this.lookBool = true;
}else{
this.goNext();
}

}else{
this.$msgbox('温馨提示：',"信息修改失败！");
}
}
})
}else{
api.post("/api/TravelInformation/addBusInformation",params).then( res=>{
if(res.data!=null){
if(res.data.results){
if(params.status=="1"){
this.onBool = false;
this.goBool = true;
this.lookBool = true;
}else{
this.goNext();
}
}else{
this.$msgbox('温馨提示：',"信息保存失败！");
}
}
})
}
}
}

}
}



// WEBPACK FOOTER //
// ./src/components/newstu/schoolInformation.vue